import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { FiZap, FiExternalLink } from 'react-icons/fi';

// CTA Node View Component
const CTANodeView = ({ node, updateAttributes, selected }) => {
  const { title, description, buttonText, buttonUrl, variant } = node.attrs;

  const handleChange = (field, value) => {
    updateAttributes({ [field]: value });
  };

  const variants = [
    { value: 'gradient', label: 'Gradient' },
    { value: 'solid', label: 'Solid' },
    { value: 'outline', label: 'Outline' },
  ];

  return (
    <NodeViewWrapper className={`cta-block cta-${variant} ${selected ? 'selected' : ''}`}>
      <div className="cta-edit-bar">
        <FiZap size={14} />
        <span>Call to Action</span>
        <div className="cta-variant-selector">
          {variants.map((v) => (
            <button
              key={v.value}
              type="button"
              className={`cta-variant-btn ${variant === v.value ? 'active' : ''}`}
              onClick={() => handleChange('variant', v.value)}
            >
              {v.label}
            </button>
          ))}
        </div>
      </div>
      <div className="cta-content-wrapper">
        <input
          type="text"
          value={title}
          onChange={(e) => handleChange('title', e.target.value)}
          placeholder="Enter headline..."
          className="cta-title-input"
        />
        <input
          type="text"
          value={description}
          onChange={(e) => handleChange('description', e.target.value)}
          placeholder="Enter description..."
          className="cta-description-input"
        />
        <div className="cta-button-row">
          <input
            type="text"
            value={buttonText}
            onChange={(e) => handleChange('buttonText', e.target.value)}
            placeholder="Button text..."
            className="cta-button-text-input"
          />
          <input
            type="url"
            value={buttonUrl}
            onChange={(e) => handleChange('buttonUrl', e.target.value)}
            placeholder="https://..."
            className="cta-button-url-input"
          />
        </div>
      </div>
      <div className="cta-preview">
        <div className="cta-preview-title">{title || 'Your Headline Here'}</div>
        <div className="cta-preview-description">
          {description || 'Your supporting text goes here'}
        </div>
        <a
          href={buttonUrl || '#'}
          className="cta-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          {buttonText || 'Click Here'}
          <FiExternalLink size={14} />
        </a>
      </div>
    </NodeViewWrapper>
  );
};

// CTA Extension
export const CTA = Node.create({
  name: 'cta',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      title: {
        default: 'Ready to Get Started?',
      },
      description: {
        default: 'Join thousands of satisfied customers today.',
      },
      buttonText: {
        default: 'Get Started',
      },
      buttonUrl: {
        default: '',
      },
      variant: {
        default: 'gradient',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="cta"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'cta' }), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CTANodeView);
  },

  addCommands() {
    return {
      insertCTA:
        (attrs = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              title: attrs.title || 'Ready to Get Started?',
              description: attrs.description || 'Join thousands of satisfied customers today.',
              buttonText: attrs.buttonText || 'Get Started',
              buttonUrl: attrs.buttonUrl || '',
              variant: attrs.variant || 'gradient',
            },
          });
        },
    };
  },
});

export default CTA;
